import { render, staticRenderFns } from "./NavigatorBottomBarLinkMeal.vue?vue&type=template&id=7ee5b09e"
import script from "./NavigatorBottomBarLinkMeal.vue?vue&type=script&lang=js"
export * from "./NavigatorBottomBarLinkMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports